import { Component, Container, HBox, VBox } from "puzzle";
import React from "react";
import { ListView, ListViewItemProps } from "@progress/kendo-react-listview";
import { COMMENT_ITEM, COMMENTS_PROPS, COMMENTS_STATE } from "./Types";
import classNames from "classnames";


class Comments extends Component<COMMENTS_PROPS, COMMENTS_STATE> {
  static defaultProps: COMMENTS_PROPS = {
    data: []
  };

  public state: COMMENTS_STATE = {};

  /**
   * Renderer for comments item
   * @param itemProps
   */
  commentItemRender = (itemProps: ListViewItemProps) => {
    const dataItem: COMMENT_ITEM = itemProps.dataItem;
    const {
      action,
      actionPhase,
      comment,
      currentUser,
      dateCreated,
      firstName,
      lastName,
      phase
    } = dataItem;
    const dateFormatted = this.translateByNamespace('date.dateWithTime', { date: new Date(dateCreated) });

    const itemClassName = classNames({
      'tp-comment-item-completed': action === 'COMPLETED',
      'tp-comment-item-demoted': action === 'DEMOTED'
    }, 'tp-comment-item');
    let fullName = `${firstName} ${lastName}`;
    if (currentUser) {
      fullName = `${fullName} ${this.translate('currentUser')}`;
    }
    return (
      <VBox className={itemClassName}>
        {comment && <VBox gap={1} className={'tp-comment-item-content'}>
          <HBox justifyContentBetween>
            <HBox gap={3}>
              {firstName && <label className={'user you tp-text-medium'}>{fullName}</label>}
              <span className={'tp-comments-date tp-color-light-LM'}>{dateFormatted}</span>
            </HBox>
            <span className={'tp-comment-phase tp-text-medium'}>{phase}</span>
          </HBox>
          <Container className={'msg tp-word-wrap'}>
            {comment}
          </Container>
        </VBox>}
        {action !== 'SAVED' && (
          <HBox
            alignItemsCenter
            justifyContentCenter
            className={`tp-comment-item-action-${action.toLowerCase()} tp-font-size-sm`}
          >
            {actionPhase ? this.translate(`actionText.${action}`, { actionPhase }) : this.translate('actionText.COMPLETED_LAST_PHASE')}
          </HBox>
        )}
      </VBox>
    );
  }

  /**
   * Load comments data
   * @param data
   */
  loadData = (data: COMMENT_ITEM[]) => {
    this.setState({
      data
    });
  }

  renderBody = () => {
    const { data } = this.props;
    const commentsListCls = classNames(
      'tp-comments-list', {
        'tp-empty': !data?.length
      }
    );

    return (
      <>
        <ListView
          className={commentsListCls}
          data={data}
          item={this.commentItemRender}
        />
      </>
    )
  }
}

export default Comments;
